import React from "react";

const DarkModeContext = React.createContext({
  darkMode: true,
  toggleDarkMode: () => {},
});

export default DarkModeContext;
